import { toggleAttributeBoolean } from '@utils';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement | null} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement | null} */ #target = this.#controller?.ariaControlsElements?.[0];
  /** @type {string | null} */ #isBlock = this.getAttribute('data-shopify-editor-block');
  /** @type {boolean} */ #isTransitioning = false;

  connectedCallback() {
    this.#controller.addEventListener('click', this.#handleClick.bind(this));

    if (this.#isBlock) {
      this.addEventListener('shopify:block:select', this.#handleBlockSelect.bind(this));
    }
  }

  /**
   * Handle controller click; toggles expanded state.
   * @returns {void}
   */
  #handleClick() {
    this.#toggle();
  }

  /**
   * Handle Shopify block select in editor; opens the collapsible.
   * @returns {void}
   */
  #handleBlockSelect() {
    this.#toggle(true);
  }

  /**
   * Toggle expanded/collapsed state, optionally forcing open.
   * @param {boolean} [forceOpen=false] - When true, force open (e.g. on block select).
   * @returns {void}
   */
  #toggle(forceOpen = false) {
    if (this.#isTransitioning) return;

    this.#isTransitioning = true;
    this.#target.addEventListener(
      'transitionend',
      () => {
        this.#isTransitioning = false;
      },
      { once: true }
    );

    toggleAttributeBoolean(this.#controller, 'aria-expanded', forceOpen ? 'true' : undefined);
    toggleAttributeBoolean(this.#target, 'aria-hidden', forceOpen ? 'false' : undefined);
  }
}

customElements.define('collapsible-element', CollapsibleElement);
